import { FileText } from "lucide-react";
import { useLocation } from "react-router-dom";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import styles from "./PagamentoBoleto.module.scss";

export const PagamentoBoleto = () => {

    const { state } = useLocation();

    const boletoUrl = state?.boletoUrl;
    const valor = state?.valor;
    const barcode = state?.barcode;

    const abrirBoleto = () => {
        if(boletoUrl){
            window.open(boletoUrl,"_blank");
        }
    };

    return (

        <PageContainer title="Pagamento por boleto">

            <div className={styles.page}>

                <FileText
                    size={55}
                    className={styles.icon}
                />

                <h2>Boleto gerado</h2>

                <p>
                    Valor
                </p>

                <strong>{valor}</strong>

                {barcode && (
                    <>
                        <p>
                            Linha digitável
                        </p>

                        <strong>{barcode}</strong>
                    </>
                )}

                <button
                    className={styles.btn}
                    onClick={abrirBoleto}
                >
                    Abrir boleto
                </button>

                <button className={styles.btnSecundario}>
                    Já realizei o pagamento
                </button>

            </div>

        </PageContainer>

    );

};